import { styled, css } from '../../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { ExpandedState } from './types';

export const navBarZIndex = 1000; // TODO: replace with a zIndex tokens from v7. https://babbel.atlassian.net/browse/DSYS-702

const styledNavBarWrapperExpanded = css`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: ${navBarZIndex};
  display: flex;
  flex-direction: column;
`;

const styledNavBarWrapperFixed = css`
  top: 0;
  z-index: ${navBarZIndex};
`;

type StyledNavBarWrapperProps = ExpandedState & {
  isFixed?: boolean;
};

const StyledNavBarWrapper = styled.div<StyledNavBarWrapperProps>`
  box-sizing: border-box;
  width: 100%;
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'static')};
  ${({ isFixed }) => isFixed && styledNavBarWrapperFixed};
  ${({ isMobileMenuExpanded }) => isMobileMenuExpanded && styledNavBarWrapperExpanded};

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    position: ${({ isFixed }) => (isFixed ? 'fixed' : 'static')};
    height: auto;
    display: block;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;

export default StyledNavBarWrapper;
